(function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };

  $.gnv.horizontalScrollableMenu =  function (){

    var init = function(){
      $('[data-target-submenu]').click(function(){
        var target = $(this).attr( "data-target-submenu" );
        $(this).toggleClass('has-arrow');
        $('.b-reserved_area_submenu#' + target ).slideToggle();
        checkVisibility(target);
      });

      $('.b-reserved_area_submenu--desktop ul li a').click(function(){
        $('.b-reserved_area_submenu--desktop ul li').removeClass('is-active');
        $(this).parent('li').addClass('is-active');
      });

      $('.b-reserved_area_submenu--mobile ul li a').click(function(){
        $('.b-reserved_area_submenu').slideUp();
        $('.b-scrollable_menu__item').removeClass('has-arrow');
      });

    };

    var checkVisibility = function(element){
      $(".b-scrollable_menu__scroll").scroll(function() {
        if ( $('.b-scrollable_menu__item.has-arrow').visible(true, false, 'horizontal') ){
        } else {
          closeSubmenu(element);
        }
      });
    };

    var closeSubmenu = function(el){
      $('.b-reserved_area_submenu#' + el ).slideUp();
      $('.b-scrollable_menu__item').removeClass('has-arrow');
    };

    init();

  };

})(jQuery);